import { render, staticRenderFns } from "./AddTechnicalParameter.vue?vue&type=template&id=8c35436a&scoped=true&"
import script from "./AddTechnicalParameter.vue?vue&type=script&lang=js&"
export * from "./AddTechnicalParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c35436a",
  null
  
)

export default component.exports